export const BASE_URL = "https://dserver.in/";
export const API_BASE_URL = "https://animal.dserver.in/api/";
export const APP_IMG_BASE_URL = "https://animal.dserver.in/";
export const CATEGORY_MENU_URL = API_BASE_URL + "category_menu";
export const CATEGORY_PROJECT_LIST_URL = API_BASE_URL + "category/"; //parameterized route * You have to pass category slug in end
export const CATEGORY_SINGLE_PROJECT_URL = API_BASE_URL + "category/"; //parameterized route * You have to pass category slug and item slug in end
export const HOME_PAGE_PROJECT_URL = API_BASE_URL + "home-projects";
